import { render, staticRenderFns } from "./PibBroadcast.vue?vue&type=template&id=5a5714e6"
import script from "./PibBroadcast.vue?vue&type=script&lang=js"
export * from "./PibBroadcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports